/**
 * AI先輩が答えない領域の画面で使う小さな決まり（issue #465）。
 */

/** 拾う言葉を1つずつに分ける（「、」「,」・改行で区切る。空・重なりは除く）。 */
export function splitKeywords(text: string): string[] {
  const words: string[] = [];
  for (const part of text.split(/[、,，\n]/)) {
    const word = part.trim();
    if (word !== '' && !words.includes(word)) words.push(word);
  }
  return words;
}
